import { DeleteData } from 'domain/entity/deleteData';
import { Result } from 'domain/types';
import DeleteReportInstanceClient from 'use-case/reportInstance/delete/deleteReportInstanceClient';
import DeleteReportInstanceCriteria from 'use-case/reportInstance/delete/deleteReportInstanceCriteria';

export type DeleteReportInstanceResult = Result<DeleteData>;
export type DeleteReportInstance = (criteria: DeleteReportInstanceCriteria) => Promise<DeleteReportInstanceResult>;

export default (deleteReportInstanceClient: DeleteReportInstanceClient): DeleteReportInstance => (
    criteria: DeleteReportInstanceCriteria
): Promise<DeleteReportInstanceResult> => deleteReportInstanceClient(criteria);
